import type { DateValue, RangeValue } from '@heroui/react';
import { create } from 'zustand';
import { EDateFilter } from '@/config';
import type { OmitFunctions } from '@/types';
import { getDateRange } from '@/utils';
import { createSelectors } from './selector';

export type UcatFilter = 'all' | 'ucat' | 'non_ucat';

interface UserBreakdownState {
  subscribed: boolean;
  ucatFilter: UcatFilter;
  dateFilter: EDateFilter;
  range: { from: Date | null | number; to: Date | null | number };
  dateRange: RangeValue<DateValue> | undefined;
  isFilterDrawerOpen: boolean;
  isLoading: boolean;

  setSubscribed: (subscribed: boolean) => void;
  setUcatFilter: (ucatFilter: UcatFilter) => void;
  setDateFilter: (dateFilter: EDateFilter) => void;
  setRange: (range: UserBreakdownState['range']) => void;
  setDateRange: (dateRange: UserBreakdownState['dateRange']) => void;
  setIsFilterDrawerOpen: (isOpen: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  reset: () => void;
}

const initialState: OmitFunctions<UserBreakdownState> = {
  subscribed: true,
  ucatFilter: 'all',
  dateFilter: EDateFilter.THIS_WEEK,
  range: getDateRange(EDateFilter.THIS_WEEK),
  dateRange: undefined,
  isFilterDrawerOpen: false,
  isLoading: false,
};

export const userBreakdownState = create<UserBreakdownState>()((set) => ({
  ...initialState,
  setSubscribed: (subscribed) => set({ subscribed }),
  setUcatFilter: (ucatFilter) => set({ ucatFilter }),
  setDateFilter: (dateFilter) => set({ dateFilter }),
  setRange: (range) => set({ range }),
  setDateRange: (dateRange) => set({ dateRange }),
  setIsFilterDrawerOpen: (isOpen) => set({ isFilterDrawerOpen: isOpen }),
  setIsLoading: (isLoading) => set({ isLoading }),
  reset: () => set(initialState),
}));

export const useUserBreakdownState = () => userBreakdownState((state) => state);
export const useUserBreakdown = createSelectors(userBreakdownState);
